<template lang="html">
<div class="choose-coupon sl-coupon" v-loading="fullLoading
">
  <row>
    <div class="sl-col-4">
      <div class="sl-coupon-form">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="title">
              <i @click="goBack()">
                < {{$t('Functional.back')}}
              </i>
              {{$t('Views.ChooseCoupon.title')}}
              </div>
            <div class="type-list">
              <router-link :to="{ name: 'Add-Coupon', query: {id:item.id,name: item.title} }" class="type" v-for="item in types" tag="div" @click.native="$ga.event('Link', item.title, 'Choose coupon')">
                <span>{{item.id}}</span>
                <span>{{item.title}}</span>
              </router-link>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="des">
              <div class="des-title">{{$t('Functional.help')}}</div>
              <div class="des-item" v-for="item,index in types">
                <p>{{item.id}}、{{item.title}}</p>
                <p>{{item.subtitle}}</p>
                <div class="">
                  <span>{{$t('Views.ChooseCoupon.example')}}:</span>
                  <ul>
                    <li v-for="it in item.example">{{it}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </row>
</div>
</template>
<script>
import api from '../../api'
export default {
  created() {
    const vm = this
    this.fullLoading = true
    api.FetchCouponType().then(res => {
      vm.types = res.data.data
      vm.fullLoading = false
    })
  },
  methods: {
    goBack() {
      this.$ga.event('Link', 'Back', 'Choose coupon')
      this.$router.back()
    }
  },
  data() {
    return {
      fullLoading: false,
      types: []
    }
  }
}
</script>
<style scoped>
.type {
  font-family: Avenir-Book;
  font-size: 18px;
  color: #4A4A4A;
  letter-spacing: 0;
  line-height: 15px;
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
  margin: 10px 0;
}

.type:hover {
  background: #FFFFFF;
  border: 1px solid #2B90E9;
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 4px;
  font-family: Avenir-Book;
  font-size: 18px;
  color: #2B90E9;
  letter-spacing: 0;
  line-height: 18px;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
}

.type>span {
  padding-left: 30px;
}

.des {
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  min-height: 50px;
  padding: 20px;
}

.des-title {
  font-family: Avenir-Book;
  font-size: 14px;
  color: #2B90E9;
  letter-spacing: 0;
  padding-bottom: 20px;
}

.des-item {
  font-family: Avenir-Book;
  font-size: 12px;
  color: #000000;
  letter-spacing: 0;
  line-height: 19px;
  padding-bottom: 20px;
}

.des-item>p:first-child {
  font-family: Avenir-Medium;
  font-size: 14px;
  color: #4A4A4A;
  letter-spacing: 0;
}

.des-item ul {
  display: inline-table;
  min-width: 200px;
}

@media only screen and (min-width: 1200px) {
  .des-item ul {
    display: inline-table;
  }
}
</style>



// WEBPACK FOOTER //
// choose-coupon.vue?36dcc883